import i18n from '@dms/i18n';
import {Main, Section} from '@dms/shared';

import {TestDrivesCalendar} from './components/TestDrivesCalendar';
import {TestDrives} from './TestDrives';

export function TestDrivesV2() {
  return (
    <Main>
      <Section
        isFullHeight
        defaultActiveTab="list"
        tabs={[
          {
            queryId: 'list',
            content: <TestDrives />,
            title: i18n.t('entity.testDrive.labels.list'),
          },
          {
            queryId: 'calendar',
            content: <TestDrivesCalendar />,
            title: i18n.t('entity.testDrive.labels.calendar'),
          },
        ]}
      />
    </Main>
  );
}
